import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import { getThousandComma } from "../../ApiTS/ApiCommonTS";
import ExcelDownload from "../../components/DefaultStyles/ExcelDownload";
import Flex from "../../components/DefaultStyles/Flex";
import LineBox from "../../components/DefaultStyles/LineBox";
import Loader from "../../components/DefaultStyles/Loader";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import YoutubeMatchingInfoFilter from "../../components/pages/Party/Youtube/YoutubeMatchingInfoFilter";
import Pagination from "../../components/Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../components/Table/Table";
import { useApi } from "../../hooks/useApi";
import { TotalCount } from "../Users/UserInfo";
import LineBtn from "../../components/Button/LineBtn";
import { atom, useRecoilState, useRecoilValue } from "recoil";
import { authType, userDataType } from "../Login";
import UplusCodeLogModal from "../../components/pages/Party/UplusMatchingInfo/UplusCodeLogModal";
import YoutubeLogModal from "../../components/pages/Party/Youtube/YoutubeLogModal";
import YoutubeUpdateModal from "../../components/pages/Party/Youtube/YoutubeUpdateModal";
import YoutubeLinkModal, { YoutubeLinkState } from "../../components/pages/Party/Youtube/YoutubeLinkModal";
import YoutubeRoundActivationModal from "../../components/pages/Party/Youtube/YoutubeRoundActivationModal";
import YoutubeProviderModal from "../../components/pages/Party/Youtube/YoutubeProviderModal";
import YoutubeRoundAccountModal from "../../components/pages/Party/Youtube/YoutubeRoundAccountModal";
import YoutubeRoundLinkModal from "../../components/pages/Party/Youtube/YoutubeRoundLinkModal";
import { generateYoutubeLink } from "../../components/pages/Party/Youtube/youtubeLinkApi";
import { saveYoutubeAllocationComment } from "../../components/pages/Party/Youtube/youtubeAllocationCommentApi";
import {
  createYoutubeCommentPreset,
  getYoutubeSubscriptionPeriod,
  YoutubeCommentPreset,
  YoutubeIssuanceType,
  YoutubeSubscriptionPeriod,
} from "../../components/pages/Party/Youtube/youtubeCommentPreset";
import CommentModal from "../../components/pages/Users/UserDetail/CommentModal/CommentModal";
import RadioBtn from "../../components/Button/RadioBtn";
import { Input } from "../../components/Input/Input";
import DefaultModalLayout from "../../components/Modal/DefaultModalLayout";
import { ModalLabel } from "../../components/pages/Users/UserDetail/CommentModal/TargetContainer";
import ToggleBtn from "../../components/Button/ToggleBtn";
import {
  PointTabColumn,
  PointTabContainer,
  PointTabText,
} from "../../components/pages/Benefit/Point/PointTab";
export interface IYoutube {
  shareid: string;
  password: string;
  backupCode: string[];
  ytstate: IYoutubeState;
  uid: number;
  partyid: number;
  nickname: string;
  servsubsid: number;
  createdate: string;
  admin: string;
  updatedate: string;
  collabo?: number;
  gptUseMyAcc?: boolean | null;
  duedate?: string;
  enddate?: string;
  extrainfo?: string;
  yt_round?: number | string | null;
  yt_r_status?: number | string | null;
  yt_r_email?: string | null;
  yt_r_link?: string | null;
  provider?: string | null;
  name?: string;
}

const ROUND_STATUS: Record<number, {
  label: string;
  description: string;
  icon: string;
  color: string;
  background: string;
}> = {
  1: {
    label: "대기",
    description: "관리자 작업 대기",
    icon: "hourglass_empty",
    color: "#92400E",
    background: "#FEF3C7",
  },
  2: {
    label: "할당 완료",
    description: "사용자 작업 대기",
    icon: "person_outline",
    color: "#1E40AF",
    background: "#DBEAFE",
  },
  3: {
    label: "활성화 완료",
    description: "회차 작업 모두 완료",
    icon: "check_circle_outline",
    color: "#166534",
    background: "#DCFCE7",
  },
};

function RoundStatus({ value }: { value: IYoutube["yt_r_status"] }) {
  if (value == null || value === "") return null;
  const status = ROUND_STATUS[Number(value)];
  if (!status) return <>{String(value)}</>;

  return (
    <RoundStatusContainer>
      <RoundStatusBadge $color={status.color} $background={status.background}>
        <span className="material-icons-outlined" aria-hidden="true">
          {status.icon}
        </span>
        {status.label}
      </RoundStatusBadge>
      <RoundStatusDescription>{status.description}</RoundStatusDescription>
    </RoundStatusContainer>
  );
}

export const copyMatchingUserInfoForExcel = async (data: IYoutube) => {
  const clipboardText = [data.partyid, data.uid, data.name, data.nickname]
    .map((value) => String(value ?? "").replace(/[\t\r\n]+/g, " "))
    .join("\t");

  try {
    await navigator.clipboard.writeText(clipboardText);
    toast.success("PID, UID, 이름, 닉네임이 복사되었습니다.");
  } catch {
    toast.error("정보를 복사하는 데에 실패하였습니다.");
  }
};

export type IYoutubeState = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
// 1: 접수 예정, 2: 접수중, 3: 처리완료, 4: 계정정보 수정 필요, 5: 백업코드 수정 필요, 6: 접수 취소, 7: 보류(추후 처리), 8: 호출완료,

// 4, 5, 7 은 2로 갈수 있다.
export const getYTStateString = (state: number) => {
  switch (state) {
    case 1:
      return "접수 예정";
    case 2:
      return "접수중";
    case 3:
      return "처리 완료";
    case 4:
      return "계정정보 수정 필요";
    case 5:
      return "백업코드 수정 필요";
    case 6:
      return "접수 취소";
    case 7:
      return "보류(추후 처리)";
    case 8:
      return "호출중";
    default:
      return "-";
  }
};

export const getCollaboString = (collabo: number) => {
  switch (collabo) {
    case 1:
      return "구독파트너";
    default:
      return "-";
  }
};

export const youtubeInfoFilterState = atom({
  key: "youtubeInfoFilterState",
  default: {
    searchType: "",
    searchValue: "",
    stateValue: "",
    roundStatusValue: "",
    providerValue: "",
    dateType: "",
    startdate: "",
    enddate: "",
    page: 0,
  },
});

type YoutubeMatchingTab = 0 | 1;

interface YoutubeMatchingInfoProps {
  servsubsidFilter?: number;
}

export default function YoutubeMatchingInfo({
  servsubsidFilter,
}: YoutubeMatchingInfoProps) {
  const navigate = useNavigate();
  const auth = useRecoilValue(authType);
  const userData = useRecoilValue(userDataType);

  const [filter, setFilter] = useRecoilState(youtubeInfoFilterState);
  const [linkModal, setLinkModal] = useState<YoutubeLinkState | null>(null);
  const [activationRound, setActivationRound] = useState<IYoutube | null>(null);
  const [providerRound, setProviderRound] = useState<IYoutube | null>(null);
  const [accountRound, setAccountRound] = useState<IYoutube | null>(null);
  const [linkEditRound, setLinkEditRound] = useState<IYoutube | null>(null);

  const handleGenerateLink = async (email: string, provider: IYoutube["provider"]) => {
    if (linkModal?.status === "loading") return;
    setLinkModal({ email, status: "loading" });
    try {
      const result = await generateYoutubeLink(email, provider);
      setLinkModal({ email, status: "success", result });
    } catch (error) {
      setLinkModal({
        email,
        status: "error",
        message: error instanceof Error ? error.message : "링크 생성에 실패했습니다.",
      });
    }
  };
  const [matchingTab, setMatchingTab] = useState<YoutubeMatchingTab>(
    filter?.stateValue === "3" ? 1 : 0,
  );
  const page = filter?.page ?? 0;
  const setPage = (nextPage: number) => {
    setFilter((prev) => ({ ...prev, page: nextPage }));
  };
  const isAll = matchingTab === 0 ? 0 : 1;

  const handleMatchingTabChange = (nextTab: YoutubeMatchingTab) => {
    setMatchingTab(nextTab);
    setFilter((prev) => ({
      ...prev,
      page: 0,
      stateValue:
        nextTab === 1 ? "3" : prev.stateValue === "3" ? "" : prev.stateValue,
    }));
  };

  const buildProxyPartyUrl = () =>
    `proxyparty?page=${page}&size=10&isall=${isAll}` +
    (servsubsidFilter ? `&servsubsid=${servsubsidFilter}` : "") +
    (filter?.searchValue !== ""
      ? `&${filter?.searchType}=${filter?.searchValue}`
      : ``) +
    (matchingTab === 1
      ? `&ytstate=3`
      : filter?.stateValue !== "" && filter?.stateValue !== "3"
        ? `&ytstate=${filter?.stateValue}`
        : ``) +
    (filter.roundStatusValue !== ""
      ? `&r_status=${filter.roundStatusValue}`
      : ``) +
    (filter.providerValue !== ""
      ? `&provider=${filter.providerValue}`
      : ``) +
    (filter?.enddate !== "" && !filter?.enddate?.includes("선택")
      ? `&datetype=${filter?.dateType}&startdate=${
          filter?.startdate
        }&enddate=${dayjs(filter?.enddate)
          ?.add(1, "day")
          ?.format("YYYY-MM-DD")}`
      : ``);

  const { response, loading, error, fetchData } = useApi({
    method: "get",
    url: buildProxyPartyUrl(),
  });
  const [viewLog, setViewLog] = useState({
    modal: false,
    partyid: 0,
  });

  const [updateModal, setUpdateModal] = useState<{
    visible: boolean;
    data: IYoutube;
    servsubsid?: number;
    dueDate?: string;
    enddate?: string;
  }>({
    visible: false,
    data: {} as IYoutube,
    servsubsid: undefined,
    dueDate: undefined,
    enddate: undefined,
  });

  const [commentModal, setCommentModal] = useState<{
    visible: boolean;
    step: "preset" | "comment";
    uid: number;
    name: string;
    nickname: string;
    partyid: number;
    servsubsid: number;
    preset?: YoutubeCommentPreset;
    iscomp?: number;
  }>({
    visible: false,
    step: "comment",
    uid: 0,
    name: "",
    nickname: "",
    partyid: 0,
    servsubsid: 0,
  });

  const tableHead = [
    "Index",
    // String(userData?.collabo) === "0" ? "Collabo" : undefined,
    "로그 확인",
    "회차",
    "회차상태",
    "Provider",
    "회차계정",
    "회차링크",
    "접수 상태",
    String(userData?.collabo) === "0" ? "PID" : undefined,
    String(userData?.collabo) === "0" ? "UID" : undefined,
    "이름",
    "닉네임",
    // "기간",
    // "목표일",
    // "생년월일",

    // "ROLE",
    // "파티 상태",
    "최초 등록일",
    "최종 수정일",
    "관리자",
    "코멘트",
  ];

  const excelHead = tableHead?.filter(
    (a) =>
      a !== "" &&
      a !== "선택" &&
      a !== "로그 확인" &&
      a !== "신청자" &&
      a !== "최종 업데이트",
  );

  useEffect(() => {
    if (error) {
      toast.error(
        error?.data ?? "유플러스 결합 정보를 가져오는 데에 실패하였습니다.",
      );
    }
  }, [error]);

  return (
    <>
      <MatchingTabContainer>
        <PointTabColumn onClick={() => handleMatchingTabChange(0)}>
          <MatchingTabText isActive={matchingTab === 0}>
            처리완료 제외
          </MatchingTabText>
        </PointTabColumn>

        <PointTabColumn onClick={() => handleMatchingTabChange(1)}>
          <MatchingTabText isActive={matchingTab === 1}>
            처리완료
          </MatchingTabText>
        </PointTabColumn>
      </MatchingTabContainer>

      <YoutubeMatchingInfoFilter
        key={matchingTab}
        pageResetEvent={() => setPage(0)}
        excludeCompletedStatus={matchingTab === 0}
        isCompletedTab={matchingTab === 1}
      />
      <Flex
        style={{ justifyContent: "flex-start", margin: "12px 0" }}
        gapSize={10}
      >
        <LineBtn
          btnColor="mint"
          btnText="새로고침"
          btnClickEvent={() => {
            fetchData({
              method: "get",
              url: buildProxyPartyUrl(),
            });
          }}
        />

        {/* <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
          }}
        >
          <ToggleBtn
            check={isAll === 1}
            checkEvent={() => setIsAll(isAll === 1 ? 0 : 1)}
          />
          처리완료 포함
        </label> */}
      </Flex>

      <LineBox key={"youtube-matching-info-box"}>
        <Table tableHeadData={tableHead} tableMinWidth={1120}>
          <>
            {response?.data?.items
              ?.filter((d: IYoutube) =>
                servsubsidFilter ? d?.servsubsid === servsubsidFilter : true,
              )
              ?.map((d: IYoutube, index: number) => {
                const roundLink = d.yt_r_link?.trim() ?? "";
                return (
                  <TableBody key={d?.partyid}>
                    <TableBodyItem isKeepAll={true}>
                      {String(userData?.collabo) === "0" ? (
                        <button
                          type="button"
                          title="PID, UID, 이름, 닉네임 복사"
                          aria-label="PID, UID, 이름, 닉네임 복사"
                          onClick={() => {
                            void copyMatchingUserInfoForExcel(d);
                          }}
                          style={{
                            minWidth: "32px",
                            padding: "4px 8px",
                            border: "1px solid #D4D9E1",
                            borderRadius: "5px",
                            background: "#FFFFFF",
                            color: "inherit",
                            font: "inherit",
                            cursor: "pointer",
                          }}
                        >
                          {response?.data?.totalCount - (page * 10 + index)}
                        </button>
                      ) : (
                        response?.data?.totalCount - (page * 10 + index)
                      )}
                    </TableBodyItem>
                    {/* {sessionStorage.getItem("collabo") === "0" && (
                    <TableBodyItem>
                      {d?.collabo}: {getCollaboString(d?.collabo ?? 1)}
                    </TableBodyItem>
                  )} */}

                    <TableBodyItem>
                      <LineBtn
                        btnText="보기"
                        btnClickEvent={() =>
                          setViewLog({
                            modal: true,
                            partyid: d?.partyid ?? 0,
                          })
                        }
                      />
                    </TableBodyItem>
                    <TableBodyItem isKeepAll={true}>
                      {d.yt_round == null ? "" : String(d.yt_round)}
                    </TableBodyItem>
                    <TableBodyItem isKeepAll={true}>
                      <RoundStatus value={d.yt_r_status} />
                    </TableBodyItem>
                    <TableBodyItem isKeepAll={true}>
                      <Flex gapSize={4}>
                        <span>{d.provider || "-"}</span>
                        <LineBtn
                          type="button"
                          icon="edit"
                          aria-label="Provider 변경"
                          title="Provider 변경"
                          btnClickEvent={() => setProviderRound({ ...d })}
                        />
                      </Flex>
                    </TableBodyItem>
                    <TableBodyItem isKeepAll={true}>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "8px" }}>
                        <Flex gapSize={4}>
                          <span>{d.yt_r_email ?? ""}</span>
                          <LineBtn
                            type="button"
                            icon="edit"
                            aria-label="회차계정 변경"
                            title="회차계정 변경"
                            btnClickEvent={() => setAccountRound({ ...d })}
                          />
                        </Flex>
                        {d.yt_r_email?.trim() && (
                          <LineBtn
                            type="button"
                            btnText="링크생성"
                            disabled={linkModal?.status === "loading"}
                            btnClickEvent={() => void handleGenerateLink(d.yt_r_email!.trim(), d.provider)}
                          />
                        )}
                      </div>
                    </TableBodyItem>
                    <TableBodyItem isKeepAll={true}>
                      {roundLink ? (
                        <Flex gapSize={4}>
                          <LineBtn
                            type="button"
                            btnText="링크확인"
                            title="작은 창에서 링크 확인"
                            btnClickEvent={() => {
                              const width = Math.min(520, window.screen.availWidth);
                              const height = Math.min(720, window.screen.availHeight);
                              const left = Math.max(0, window.screenX + (window.outerWidth - width) / 2);
                              const top = Math.max(0, window.screenY + (window.outerHeight - height) / 2);
                              window.open(
                                roundLink,
                                "_blank",
                                `popup=yes,width=${width},height=${height},left=${Math.round(left)},top=${Math.round(top)},resizable=yes,scrollbars=yes,noopener,noreferrer`,
                              );
                              if (Number(d.yt_r_status) === 2) {
                                setActivationRound({ ...d });
                              }
                            }}
                          />
                          <LineBtn
                            type="button"
                            icon="edit"
                            aria-label="회차링크 변경"
                            title="회차링크 변경"
                            btnClickEvent={() => setLinkEditRound({ ...d })}
                          />
                        </Flex>
                      ) : (
                        "-"
                      )}
                    </TableBodyItem>

                    <TableBodyItem>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          gap: "8px",
                        }}
                      >
                        <span
                          style={{
                            display: "inline-block",
                            padding: "4px 12px",
                            borderRadius: "16px",
                            fontSize: "13px",
                            fontWeight: 600,
                            backgroundColor:
                              d?.ytstate === 1
                                ? "#FFF3E0"
                                : d?.ytstate === 2
                                  ? "#E3F2FD"
                                  : d?.ytstate === 3
                                    ? "#E8F5E9"
                                    : d?.ytstate === 4 ||
                                        d?.ytstate === 5 ||
                                        d?.ytstate === 8
                                      ? "#FFEBEE"
                                      : "#F5F5F5",
                            color:
                              d?.ytstate === 1
                                ? "#E65100"
                                : d?.ytstate === 2
                                  ? "#1565C0"
                                  : d?.ytstate === 3
                                    ? "#2E7D32"
                                    : d?.ytstate === 4 ||
                                        d?.ytstate === 5 ||
                                        d?.ytstate === 8
                                      ? "#C62828"
                                      : "#616161",
                          }}
                        >
                          <div style={{  alignItems: "center" }}>
                          {getYTStateString(d?.ytstate)}
                          {/* 처리완료인데 연장필요일때는 태그하나 추가한다. */}
                          {d?.ytstate === 3 && matchingTab === 0 && (
                            <div
                              style={{
                                marginLeft: "0px",
                                // padding: "2px 8px",
                                fontSize: "10px",
                                textAlign: "center",
                                backgroundColor: "#FFEBEE",
                                color: "#C62828",
                                border: "1px solid #FFCDD2",
                              }}
                            >
                              연장
                            </div>
                          )}
                          </div>
                        </span>
                        {d?.duedate &&
                          (d?.ytstate === 7 || d?.ytstate === 3) && (
                            <span
                              style={{
                                color:
                                  dayjs(d?.duedate).format("YYYY-MM-DD") >
                                  dayjs().format("YYYY-MM-DD")
                                    ? "#000000"
                                    : "#D32F2F",
                                fontWeight:
                                  dayjs(d?.duedate).format("YYYY-MM-DD") >
                                  dayjs().format("YYYY-MM-DD")
                                    ? "500"
                                    : "900",
                              }}
                            >
                              {d?.enddate === d?.duedate ? (
                                <div
                                  style={{
                                    textDecorationLine: "line-through",
                                  }}
                                >
                                  종료일까지
                                </div>
                              ) : (
                                `${dayjs(d?.duedate).format("YYYY-MM-DD")}`
                              )}
                            </span>
                          )}

                        <LineBtn
                          btnText="상태변경하기"
                          btnClickEvent={() => {
                            setUpdateModal({
                              visible: true,
                              data: d,
                              servsubsid: d?.servsubsid,
                              dueDate: d?.duedate,
                              enddate: d?.enddate,
                            });
                          }}
                          // disabled={d?.ytstate === 3 ? true : false}
                          disabled={false}
                          style={{
                            padding: "6px 12px",
                            borderRadius: "6px",
                          }}
                        />
                      </div>
                    </TableBodyItem>
                    {String(userData?.collabo) === "0" && (
                      <TableBodyItem
                        isKeepAll={true}
                        clickable={d?.partyid ? true : false}
                        onClick={() => {
                          if (d?.partyid > 0) {
                            setFilter((prev) => ({ ...prev, page }));
                            navigate(`/party/info/${d?.partyid ?? 0}`);
                          }
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                          }}
                        >
                          <span>{d?.partyid ?? "-"}</span>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              navigator.clipboard.writeText(
                                String(d?.partyid ?? ""),
                              );
                              toast.success("PID가 복사되었습니다.");
                            }}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px",
                              padding: "8px 14px",
                              backgroundColor: "#F5F5F5",
                              border: "1px solid #E0E0E0",
                              borderRadius: "8px",
                              cursor: "pointer",
                              transition: "background-color 0.2s",
                              fontSize: "13px",
                              fontWeight: 500,
                              color: "#555",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#D0D0D0")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#F5F5F5")
                            }
                          >
                            <span
                              className="material-icons-outlined"
                              style={{ fontSize: "18px", color: "#555" }}
                            >
                              content_copy
                            </span>
                          </button>
                        </div>
                      </TableBodyItem>
                    )}
                    {String(userData?.collabo) === "0" && (
                      <TableBodyItem
                        isKeepAll={true}
                        clickable={d?.uid > 0 ? true : false}
                        onClick={() => {
                          if (d?.uid > 0) {
                            setFilter((prev) => ({ ...prev, page }));
                            navigate(`/users/info/${d?.uid ?? 0}`);
                          }
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                          }}
                        >
                          <span>{d?.uid ?? "-"}</span>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              navigator.clipboard.writeText(
                                String(d?.uid ?? ""),
                              );
                              toast.success("UID가 복사되었습니다.");
                            }}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px",
                              padding: "8px 14px",
                              backgroundColor: "#F5F5F5",
                              border: "1px solid #E0E0E0",
                              borderRadius: "8px",
                              cursor: "pointer",
                              transition: "background-color 0.2s",
                              fontSize: "13px",
                              fontWeight: 500,
                              color: "#555",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#D0D0D0")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#F5F5F5")
                            }
                          >
                            <span
                              className="material-icons-outlined"
                              style={{ fontSize: "18px", color: "#555" }}
                            >
                              content_copy
                            </span>
                          </button>
                        </div>
                      </TableBodyItem>
                    )}
                    <TableBodyItem isKeepAll={true} clickable={false}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                        }}
                      >
                        <span>{d?.name ?? "-"}</span>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(d?.name ?? "");
                            toast.success("이름이 복사되었습니다.");
                          }}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            padding: "8px 14px",
                            backgroundColor: "#F5F5F5",
                            border: "1px solid #E0E0E0",
                            borderRadius: "8px",
                            cursor: "pointer",
                            transition: "background-color 0.2s",
                            fontSize: "13px",
                            fontWeight: 500,
                            color: "#555",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.backgroundColor = "#D0D0D0")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.backgroundColor = "#F5F5F5")
                          }
                        >
                          <span
                            className="material-icons-outlined"
                            style={{ fontSize: "18px", color: "#555" }}
                          >
                            content_copy
                          </span>
                        </button>
                      </div>
                    </TableBodyItem>
                    {/* 닉네임 */}
                    <TableBodyItem isKeepAll={true} clickable={false}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "flex-start",
                          gap: "8px",
                        }}
                      >
                        {d?.nickname ?? "-"}
                        <button
                          onClick={() => {
                            navigator.clipboard.writeText(d?.nickname ?? "");
                            toast.success("닉네임이 복사되었습니다.");
                          }}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            padding: "8px 14px",
                            backgroundColor: "#F5F5F5",
                            border: "1px solid #E0E0E0",
                            borderRadius: "8px",
                            cursor: "pointer",
                            transition: "background-color 0.2s",
                            fontSize: "13px",
                            fontWeight: 500,
                            color: "#555",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.backgroundColor = "#D0D0D0")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.backgroundColor = "#E8E8E8")
                          }
                        >
                          <span
                            className="material-icons-outlined"
                            style={{ fontSize: "18px", color: "#555" }}
                          >
                            content_copy
                          </span>
                        </button>
                      </div>
                    </TableBodyItem>

                    {/* 목표일 */}
                    {/* <TableBodyItem isKeepAll={true} clickable={false}>
                    {d?.duedate
                      ? dayjs(d?.duedate ?? undefined)?.format("YYYY-MM-DD")
                      : "-"}
                  </TableBodyItem> */}

                    {/* 파티기간 */}
                    {/* <TableBodyItem isKeepAll={true} clickable={false}>
                    {d?.servsubsid === 37000 ? "6개월" : "12개월"}
                  </TableBodyItem> */}

                    <TableBodyItem isKeepAll={true}>
                      {d?.createdate
                        ? dayjs(d?.createdate ?? undefined)?.format(
                            "YYYY.MM.DD HH:mm",
                          )
                        : "-"}
                    </TableBodyItem>
                    <TableBodyItem isKeepAll={true}>
                      {d?.updatedate
                        ? dayjs(d?.updatedate ?? undefined)?.format(
                            "YYYY.MM.DD HH:mm",
                          )
                        : "-"}
                    </TableBodyItem>
                    <TableBodyItem>
                      {d?.admin?.length > 0 ? d?.admin : "-"}
                    </TableBodyItem>

                    <TableBodyItem>
                      <LineBtn
                        btnText="코멘트 작성"
                        btnClickEvent={() =>
                          setCommentModal({
                            visible: true,
                            step: "comment",
                            uid: d?.uid,
                            name: "",
                            nickname: d?.nickname ?? "",
                            partyid: d?.partyid ?? 0,
                            servsubsid: d?.servsubsid ?? 0,
                          })
                        }
                      />
                    </TableBodyItem>
                  </TableBody>
                );
              })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response?.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0,
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      <SpaceBetween>
        <div />
      </SpaceBetween>

      {linkEditRound && (
        <YoutubeRoundLinkModal
          round={linkEditRound}
          closeEvent={() => setLinkEditRound(null)}
          onSaved={() => {
            setLinkEditRound(null);
            void fetchData({ method: "get", url: buildProxyPartyUrl() });
          }}
        />
      )}

      {providerRound && (
        <YoutubeProviderModal
          round={providerRound}
          closeEvent={() => setProviderRound(null)}
          onSaved={() => {
            setProviderRound(null);
            void fetchData({ method: "get", url: buildProxyPartyUrl() });
          }}
        />
      )}

      {accountRound && (
        <YoutubeRoundAccountModal
          round={accountRound}
          closeEvent={() => setAccountRound(null)}
          onSaved={() => {
            setAccountRound(null);
            void fetchData({ method: "get", url: buildProxyPartyUrl() });
          }}
        />
      )}

      {activationRound && (
        <YoutubeRoundActivationModal
          round={activationRound}
          closeEvent={() => setActivationRound(null)}
          onSaved={() => {
            setActivationRound(null);
            void fetchData({ method: "get", url: buildProxyPartyUrl() });
          }}
        />
      )}

      {linkModal && (
        <YoutubeLinkModal
          state={linkModal}
          closeEvent={() => {
            if (linkModal.status !== "loading") setLinkModal(null);
          }}
        />
      )}

      {viewLog?.modal && (
        <YoutubeLogModal
          closeEvent={() =>
            setViewLog({
              modal: false,
              partyid: 0,
            })
          }
          // confirmEvent={() => closeEvent()}
          partyid={viewLog?.partyid}
        />
      )}

      {updateModal.visible && (
        <YoutubeUpdateModal
          closeEvent={() =>
            setUpdateModal({
              visible: false,
              data: {} as IYoutube,
              servsubsid: undefined,
            })
          }
          confirmEvent={() => {
            fetchData({
              method: "get",
              url: buildProxyPartyUrl(),
            });
          }}
          onAllocationSaved={async (preset) => {
            setUpdateModal((prev) => ({ ...prev, visible: false }));
            try {
              await saveYoutubeAllocationComment(
                updateModal.data.uid,
                updateModal.data.partyid,
                preset,
              );
              toast.success("코멘트가 추가되었습니다.");
            } catch {
              toast.error("할당은 저장되었지만 코멘트 자동 저장에 실패했습니다. 코멘트를 확인 후 다시 저장해 주세요.");
              setCommentModal({
                visible: true,
                step: "comment",
                uid: updateModal.data.uid,
                name: updateModal.data.name ?? "",
                nickname: updateModal.data.nickname ?? "",
                partyid: updateModal.data.partyid,
                servsubsid: updateModal.data.servsubsid,
                preset,
                iscomp: 2,
              });
            }
          }}
          uid={updateModal?.data?.uid}
          partyid={updateModal?.data?.partyid}
          ytstate={updateModal?.data?.ytstate}
          servsubsid={updateModal?.servsubsid ?? 0}
          dueDate={updateModal?.data?.duedate}
          enddate={updateModal?.data?.enddate}
          ytRound={updateModal?.data?.yt_round}
          ytRoundStatus={updateModal?.data?.yt_r_status}
          ytRoundEmail={updateModal?.data?.yt_r_email}
          ytRoundLink={updateModal?.data?.yt_r_link}
          provider={updateModal?.data?.provider}
        />
      )}

      {commentModal.visible &&
        (commentModal.step === "preset" ? (
          <YoutubeCommentPresetModal
            subscriptionPeriod={getYoutubeSubscriptionPeriod(commentModal.servsubsid)}
            closeEvent={() =>
              setCommentModal((prev) => ({
                ...prev,
                visible: false,
                preset: undefined,
              }))
            }
            confirmEvent={(preset) =>
              setCommentModal((prev) => ({
                ...prev,
                step: "comment",
                preset,
              }))
            }
          />
        ) : (
          <CommentModal
            closeEvent={() =>
              setCommentModal({
                visible: false,
                step: "comment",
                uid: 0,
                name: "",
                nickname: "",
                partyid: 0,
                servsubsid: 0,
                preset: undefined,
              })
            }
            confirmEvent={() =>
              setCommentModal({
                visible: false,
                step: "comment",
                uid: 0,
                name: "",
                nickname: "",
                partyid: 0,
                servsubsid: 0,
                preset: undefined,
              })
            }
            type="input"
            commentData={
              {
                uid: commentModal.uid,
                name: commentModal.name,
                nickname: commentModal.nickname,
                partyId: String(commentModal.partyid),
                servsubsid: commentModal.servsubsid,
                tag: commentModal.preset?.tag,
                content: commentModal.preset?.content,
                iscomp: commentModal.iscomp,
              } as any
            }
          />
        ))}

      {loading && <Loader />}
    </>
  );
}

const RoundStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;

const RoundStatusBadge = styled.span<{ $color: string; $background: string }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border-radius: 16px;
  background: ${({ $background }) => $background};
  color: ${({ $color }) => $color};
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;

  .material-icons-outlined {
    font-size: 18px;
  }
`;

const RoundStatusDescription = styled.span`
  color: #4B5563;
  font-size: 12px;
  line-height: 18px;
  white-space: nowrap;
`;

const MatchingTabContainer = styled(PointTabContainer)`
  margin-bottom: 18px;
`;

const MatchingTabText = styled(PointTabText)`
  display: inline-block;
  padding-bottom: 8px;
  border-bottom: 3px solid
    ${({ isActive, theme }) => (isActive ? theme.color.gray900 : "transparent")};
`;

const YOUTUBE_REISSUE_ROUNDS = Array.from(
  { length: 12 },
  (_, index) => index + 1,
);

interface YoutubeCommentPresetModalProps {
  subscriptionPeriod: YoutubeSubscriptionPeriod;
  closeEvent: () => void;
  confirmEvent: (preset: YoutubeCommentPreset) => void;
}

function YoutubeCommentPresetModal({
  subscriptionPeriod,
  closeEvent,
  confirmEvent,
}: YoutubeCommentPresetModalProps) {
  const [issuanceType, setIssuanceType] = useState<YoutubeIssuanceType>("new");
  const [reissueRound, setReissueRound] = useState(1);
  const [account, setAccount] = useState("");
  const [roundStartDate, setRoundStartDate] = useState("");
  const isReissue = issuanceType === "reissue";

  const createPreset = (): YoutubeCommentPreset => {
    return createYoutubeCommentPreset({
      issuanceType,
      round: reissueRound,
      subscriptionPeriod,
      account,
      roundStartDate,
    });
  };

  return (
    <DefaultModalLayout
      type="input"
      modalTitle="코멘트 프리셋"
      modalDesc="프리셋을 설정하면 다음 단계의 코멘트에 자동으로 입력됩니다."
      closeEvent={closeEvent}
      confirmEvent={() => confirmEvent(createPreset())}
      confirmDisabled={
        account.trim() === "" || (isReissue && roundStartDate === "")
      }
      confirmBtnText="코멘트 작성"
    >
      <YoutubePresetField>
        <ModalLabel>발급 구분</ModalLabel>
        <YoutubePresetOptionRow>
          <RadioBtn
            label="신규발급"
            check={issuanceType === "new"}
            clickEvent={() => setIssuanceType("new")}
            noTooltip
            sHeight={38}
          />
          <RadioBtn
            label="재발급"
            check={isReissue}
            clickEvent={() => setIssuanceType("reissue")}
            noTooltip
            sHeight={38}
          />
        </YoutubePresetOptionRow>
      </YoutubePresetField>

      {isReissue ? (
        <YoutubePresetField>
          <ModalLabel>재발급 회차</ModalLabel>
          <YoutubePresetSelect
            value={reissueRound}
            onChange={(event) => setReissueRound(Number(event.target.value))}
          >
            {YOUTUBE_REISSUE_ROUNDS.slice(0, subscriptionPeriod).map(
              (round) => (
                <option key={round} value={round}>
                  {round}회차
                </option>
              ),
            )}
          </YoutubePresetSelect>
        </YoutubePresetField>
      ) : (
        <></>
      )}

      <YoutubePresetField>
        <ModalLabel>적용 계정</ModalLabel>
        <Input
          value={account}
          onChange={(event) => setAccount(event.target.value)}
          placeholder="적용 계정 입력 (필수)"
        />
      </YoutubePresetField>

      {isReissue ? (
        <YoutubePresetField>
          <ModalLabel>{reissueRound}회차 시작일</ModalLabel>
          <Input
            type="date"
            value={roundStartDate}
            onChange={(event) => setRoundStartDate(event.target.value)}
          />
        </YoutubePresetField>
      ) : (
        <></>
      )}
    </DefaultModalLayout>
  );
}

const YoutubePresetField = styled.div`
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 18px;
  }
`;

const YoutubePresetOptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 28px;
  margin-top: 8px;
`;

const YoutubePresetSelect = styled.select`
  width: 100%;
  height: 38px;
  margin-top: 8px;
  padding: 0 16px;
  border: 1px solid transparent;
  border-radius: 3px;
  background-color: ${({ theme }) => theme.color.bgColor};
  color: #1e1e1e;
  font-size: 14px;
  font-weight: 500;

  &:focus {
    border-color: #00c7c7;
    background-color: #ffffff;
  }
`;
